'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import refType from '@mui/utils/refType';
import composeClasses from '@mui/utils/composeClasses';
import { useFormControl } from "../FormControl/index.js";
import { styled } from "../zero-styled/index.js";
import memoTheme from "../utils/memoTheme.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
import Typography from "../Typography/index.js";
import capitalize from "../utils/capitalize.js";
import formControlLabelClasses, { getFormControlLabelUtilityClasses } from "./formControlLabelClasses.js";
import formControlState from "../FormControl/formControlState.js";
import useSlot from "../utils/useSlot.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, disabled = ownerState.disabled, labelPlacement = ownerState.labelPlacement, error = ownerState.error, required = ownerState.required;
    var slots = {
        root: [
            'root',
            disabled && 'disabled',
            "labelPlacement".concat(capitalize(labelPlacement)),
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return composeClasses(slots, getFormControlLabelUtilityClasses, classes);
};
export var FormControlLabelRoot = styled('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            _define_property({}, "& .".concat(formControlLabelClasses.label), styles.label),
            styles.root,
            styles["labelPlacement".concat(capitalize(ownerState.labelPlacement))]
        ];
    }
})(memoTheme(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16
    }, // used for row presentation of radio/checkbox
    _define_property(_obj, "&.".concat(formControlLabelClasses.disabled), {
        cursor: 'default'
    }), _define_property(_obj, "& .".concat(formControlLabelClasses.label), _define_property({}, "&.".concat(formControlLabelClasses.disabled), {
        color: (theme.vars || theme).palette.text.disabled
    })), _define_property(_obj, "variants", [
        {
            props: {
                labelPlacement: 'start'
            },
            style: {
                flexDirection: 'row-reverse',
                marginRight: -11
            }
        },
        {
            props: {
                labelPlacement: 'top'
            },
            style: {
                flexDirection: 'column-reverse'
            }
        },
        {
            props: {
                labelPlacement: 'bottom'
            },
            style: {
                flexDirection: 'column'
            }
        },
        {
            props: function(param) {
                var labelPlacement = param.labelPlacement;
                return labelPlacement === 'start' || labelPlacement === 'top' || labelPlacement === 'bottom';
            },
            style: {
                marginLeft: 16 // used for row presentation of radio/checkbox
            }
        }
    ]), _obj;
}));
var AsteriskComponent = styled('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: function(props, styles) {
        return styles.asterisk;
    }
})(memoTheme(function(param) {
    var theme = param.theme;
    return _define_property({}, "&.".concat(formControlLabelClasses.error), {
        color: (theme.vars || theme).palette.error.main
    });
}));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ var FormControlLabel = /*#__PURE__*/ React.forwardRef(function FormControlLabel(inProps, ref) {
    var props = useDefaultProps({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    var checked = props.checked, className = props.className, _props_componentsProps = props.componentsProps, componentsProps = _props_componentsProps === void 0 ? {} : _props_componentsProps, control = props.control, disabledProp = props.disabled, disableTypography = props.disableTypography, inputRef = props.inputRef, labelProp = props.label, _props_labelPlacement = props.labelPlacement, labelPlacement = _props_labelPlacement === void 0 ? 'end' : _props_labelPlacement, name = props.name, onChange = props.onChange, requiredProp = props.required, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, value = props.value, other = _object_without_properties(props, [
        "checked",
        "className",
        "componentsProps",
        "control",
        "disabled",
        "disableTypography",
        "inputRef",
        "label",
        "labelPlacement",
        "name",
        "onChange",
        "required",
        "slots",
        "slotProps",
        "value"
    ]);
    var muiFormControl = useFormControl();
    var _ref;
    var disabled = (_ref = disabledProp !== null && disabledProp !== void 0 ? disabledProp : control.props.disabled) !== null && _ref !== void 0 ? _ref : muiFormControl === null || muiFormControl === void 0 ? void 0 : muiFormControl.disabled;
    var required = requiredProp !== null && requiredProp !== void 0 ? requiredProp : control.props.required;
    var controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach(function(key) {
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
            controlProps[key] = props[key];
        }
    });
    var fcs = formControlState({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    var ownerState = _object_spread_props(_object_spread({}, props), {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    var classes = useUtilityClasses(ownerState);
    var externalForwardedProps = {
        slots: slots,
        slotProps: _object_spread({}, componentsProps, slotProps)
    };
    var _useSlot = _sliced_to_array(useSlot('typography', {
        elementType: Typography,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), TypographySlot = _useSlot[0], typographySlotProps = _useSlot[1];
    var label = labelProp;
    if (label != null && label.type !== Typography && !disableTypography) {
        label = /*#__PURE__*/ _jsx(TypographySlot, _object_spread_props(_object_spread({
            component: "span"
        }, typographySlotProps), {
            className: clsx(classes.label, typographySlotProps === null || typographySlotProps === void 0 ? void 0 : typographySlotProps.className),
            children: label
        }));
    }
    return /*#__PURE__*/ _jsxs(FormControlLabelRoot, _object_spread_props(_object_spread({
        className: clsx(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other), {
        children: [
            /*#__PURE__*/ React.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ _jsxs("div", {
                children: [
                    label,
                    /*#__PURE__*/ _jsxs(AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
process.env.NODE_ENV !== "production" ? FormControlLabel.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the component appears selected.
   */ checked: PropTypes.bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: PropTypes.object,
    /**
   * @ignore
   */ className: PropTypes.string,
    /**
   * The props used for each slot inside.
   * @default {}
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ componentsProps: PropTypes.shape({
        typography: PropTypes.object
    }),
    /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */ control: PropTypes.element.isRequired,
    /**
   * If `true`, the control is disabled.
   */ disabled: PropTypes.bool,
    /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */ disableTypography: PropTypes.bool,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: refType,
    /**
   * A text or an element to be used in an enclosing label element.
   */ label: PropTypes.node,
    /**
   * The position of the label.
   * @default 'end'
   */ labelPlacement: PropTypes.oneOf([
        'bottom',
        'end',
        'start',
        'top'
    ]),
    /**
   * @ignore
   */ name: PropTypes.string,
    /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: PropTypes.func,
    /**
   * If `true`, the label will indicate that the `input` is required.
   */ required: PropTypes.bool,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: PropTypes.shape({
        typography: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: PropTypes.shape({
        typography: PropTypes.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object,
            PropTypes.bool
        ])),
        PropTypes.func,
        PropTypes.object
    ]),
    /**
   * The value of the component.
   */ value: PropTypes.any
} : void 0;
export default FormControlLabel;
